<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon>event</mat-icon>
				<span *ngIf="!news.id">Newserstellung</span>
				<span *ngIf="news.id">Newsausgabe</span>
			</div>

			<mat-spinner diameter=30 [ngStyle]="{ opacity: bLoading ? '1' : '0' }" />

		</div>

		<div style="padding:1em; margin: 0em auto 0 auto; position: relative">

			<div
				*ngIf="bError"
				class="noElements"
			>
				Beim Laden der Nachrichten ist ein Fehler aufgetreten
			</div>
		
			<div *ngIf="!bLoading && !bError" class="mainCol">

				<div>
					<div class="labelLine">Überschrift</div>
					<div>
						{{ news.title }}
					</div>
				</div>

				<div>
					<div class="labelLine">News Rubriken</div>
					<div>
						{{ strRubrics }}
					</div>
				</div>

				<div>
					<div class="labelLine">Kategorien</div>
					<div>
						{{ strCategories }}
					</div>
				</div>

				<div>
					<div class="labelLine">Anrede</div>
					<div>
						{{ news.contactTitle }}
					</div>
				</div>
			
				<div class="twoFields">
					
					<div>
						<div class="labelLine">Name</div>
						<div>
							{{ news.contactFamilyName }}
						</div>
					</div>

					<div>
						<div class="labelLine">Vorname</div>
						<div>
							{{ news.contactFirstName }}
						</div>
					</div>

				</div>

				<div>
					<div class="labelLine">Telefonnummer</div>
					<div>
						{{ news.contactPhone }}
					</div>
				</div>

				<div>
					<div class="labelLine">Email</div>
					<div>
						{{ news.contactEmail }}
					</div>
				</div>

				<div *ngIf="news.url">
					<div class="label">Url</div>
					<div>
						{{ news.url }}
					</div>
				</div>

				<div *ngIf="!news.url">
					<div class="labelLine">Innerhalt</div>
					<div class="htmlViewer" [innerHTML]="domSanitizer.bypassSecurityTrustHtml( news.content )"></div>
				</div>

				<div>

					<div class="labelLine">Angehängte Dateien</div>

					<div *ngIf="news.myFiles.length">

						<div
							*ngFor="let attachedFile of news.myFiles"
							class="fileLine"
						>
							<div class="fileNameAndDelete">
								<span
									class="fileName"
									(click)="downloadFile(attachedFile)"
								>
									{{attachedFile.file.name}}
								</span>
							</div>
			
						</div>

					</div>

					<div
						*ngIf="!news.myFiles.length"
						class="noElements"
					>
						Keine
					</div>

				</div>

			</div>

		</div>

	</div>

</div>

